module.exports = __webpack_public_path__ + "img/coupon_bg_02.d730d0f1.jpg";